// Link ai messaggi: /messaggi/<id thread> apre direttamente quel thread (è l'href delle notifiche push).
// Restituisce l'id del thread o null se l'indirizzo non è di quel tipo.
export function threadIdFromPath(pathname) {
  if (typeof pathname !== "string") return null;
  const match = pathname.trim().match(/^\/messaggi\/(\d{1,12})\/?$/i);
  return match ? Number(match[1]) : null;
}
